import { type NodeRenderer } from '@contentful/rich-text-react-renderer'
import React, { Children, cloneElement, isValidElement } from 'react'

export const olList: NodeRenderer = (node, children) => {
  // Add index and set ordered mode to child ListItems
  const childrenWithProps = Children.map(children, (child, i) => {
    if (isValidElement(child)) {
      return cloneElement(child, { isOrdered: true, index: i + 1 })
    }

    return child
  })

  return <ol className="table-row-group py-2">{childrenWithProps}</ol>
}
